import { render, staticRenderFns } from "./sw-app-header.vue?vue&type=template&id=625bf361&"
import script from "./sw-app-header.vue?vue&type=script&lang=tsx&"
export * from "./sw-app-header.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-app-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports